import Flatpickr from 'stimulus-flatpickr'
import monthSelect from 'flatpickr/dist/plugins/monthSelect';
import {Japanese} from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default class extends Flatpickr {
    connect() {
        console.log('connect admin schedules flatpickr')
        this.config = {
            locale: Japanese,
            plugins: [
                new monthSelect({
                    dateFormat: "Y年m月",
                })
            ],
        }

        super.connect();
    }

    submit() {
        console.log('submit');
        const form = this.element.form || this.element.closest('form')
        if (!form) return
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit()
        } else {
            form.submit()
        }
    }

}
